export default __webpack_public_path__ + "images/assets/c0f99f3757dc62f50f95a5ab0c02b403.svg";